// extracted by mini-css-extract-plugin
export var childrenContainer = "_5a-0";
export var virtualScrollArea = "_5a-1";